interface IconProps {
  className?: string
}

// Client-provided category icons. Static PNGs in /public/icons/categories/
// — colours are baked into the assets, not controlled by CSS.
export function MarketplaceIcon({ className = 'w-10 h-10' }: IconProps) {
  return <img src="/icons/categories/marketplace.png" alt="Marketplace" className={className} />
}

export function AutomotiveIcon({ className = 'w-10 h-10' }: IconProps) {
  return <img src="/icons/categories/automotive.png" alt="Automotive" className={className} />
}

export function FundraiserIcon({ className = 'w-10 h-10' }: IconProps) {
  return <img src="/icons/categories/fundraiser.png" alt="Fundraiser" className={className} />
}

// Property icon — house silhouette (no PNG asset yet, so inline SVG)
// Brand colours: Green #48c37e, Dark #242c29
export function PropertyIcon({ className = 'w-10 h-10' }: IconProps) {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* House body */}
      <rect x="12" y="24" width="24" height="18" rx="2" fill="#48c37e" />
      {/* Roof */}
      <path d="M6 26L24 10L42 26" stroke="#242c29" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M10 24L24 12L38 24V42H10V24Z" fill="#48c37e" />
      {/* Door */}
      <rect x="20" y="30" width="8" height="12" rx="1" fill="#242c29" opacity="0.4" />
      {/* Window */}
      <rect x="14" y="26" width="6" height="5" rx="1" fill="white" opacity="0.7" />
      <rect x="28" y="26" width="6" height="5" rx="1" fill="white" opacity="0.7" />
      {/* Chimney */}
      <rect x="32" y="14" width="4" height="10" fill="#242c29" opacity="0.3" />
    </svg>
  )
}

// Mapping function: group icon key -> React component
const ICON_MAP: Record<string, React.ComponentType<IconProps>> = {
  marketplace: MarketplaceIcon,
  automotive: AutomotiveIcon,
  fundraiser: FundraiserIcon,
  property: PropertyIcon,
}

// Render a category group icon by its key string
export function CategoryGroupIcon({ iconKey, className }: { iconKey: string; className?: string }) {
  const Icon = ICON_MAP[iconKey]
  if (!Icon) return null
  return <Icon className={className} />
}
